// extracted by mini-css-extract-plugin
module.exports = {"contents":"_1ATRi_cDStkz2x3KTkl3Oz","text":"_2J28n-IYzCY_d7_mK-g2Y1"};